export default {
      id: "ic_filter_transparan_dark-usage",
      viewBox: "0 0 24 24",
      url: "/" + "images/icons.3.109.2.svg#ic_filter_transparan_dark-usage",
      toString: function () {
        return this.url;
      }
    }